import { render, staticRenderFns } from "./YardInspectionsTable.vue?vue&type=template&id=483a3ff9&"
import script from "./YardInspectionsTable.vue?vue&type=script&lang=js&"
export * from "./YardInspectionsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports